import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Tuple } from '@reduxjs/toolkit';
import { SuperTokensWrapper } from 'supertokens-auth-react';
import { initialiseSupertokensAuth } from 'supertokens-auth';
import { initGoogleMapsApiKey } from 'cb-front-end';
import { gCacheMiddleware, makeStore, setConfig, userMiddleware } from 'gossamer-front-end';
import { PostHogProvider } from 'posthog-js/react';
import posthog, { PostHogConfig } from 'posthog-js';
import { LoggedInRoutes } from './Routes';
import './Model'; // setReduxEntitites()
import { registerServiceWorker } from './serviceWorkerRegistration';

setConfig('gossamer-be-origin', process.env.GOSSAMER_BE_ORIGIN);
setConfig('gossamer-fe-origin', process.env.GOSSAMER_FE_ORIGIN);
setConfig('gossamer-api-path', process.env.GOSSAMER_API_PATH);
setConfig('main-fe-origin', process.env.MAIN_FE_ORIGIN);
setConfig('built-at', process.env.BUILT_AT);
setConfig('generic-mode', process.env.GENERIC_MODE);
setConfig('session-token-frontend-domain', process.env.SUPERTOKENS_COOKIE_DOMAIN || undefined);
setConfig(
  'stripe-publishable-key',
  process.env.STRIPE_PUBLISHABLE_KEY || process.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
);
setConfig('livekit-ws-url', process.env.LIVEKIT_WS_URL || process.env.VITE_APP_LIVEKIT_WS_URL || '');

initialiseSupertokensAuth();

if (process.env.GOOGLE_MAPS_API_KEY) {
  initGoogleMapsApiKey(process.env.GOOGLE_MAPS_API_KEY);
}

const posthogKey = process.env.POSTHOG_API_KEY;
const posthogOptions: Partial<PostHogConfig> = {
  api_host: process.env.POSTHOG_API_HOST,
  defaults: '2026-05-30',
};
if (posthogKey) {
  posthog.init(posthogKey, posthogOptions);
}

const App = (): React.JSX.Element => {
  const store = makeStore(() => new Tuple(gCacheMiddleware, userMiddleware));
  return (
    <React.StrictMode>
      <SuperTokensWrapper>
        <Provider store={store}>
          {!!posthogKey && (
            <PostHogProvider client={posthog}>
              <LoggedInRoutes />
            </PostHogProvider>
          )}
          {!posthogKey && <LoggedInRoutes />}
        </Provider>
      </SuperTokensWrapper>
    </React.StrictMode>
  );
};

const container = document.querySelector('#app');
const root = createRoot(container!);
root.render(<App />);

registerServiceWorker();
